import src from "IMAGE";
export default { src, width: 222, height: 42, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AE1NTT1LS0s8Pz8/M0NFQzgfORk/GzIWNjA6MiohVCl7AExMTD1LS0s9NDQ0LDg5NzEdNRc9GjAVNC43LSYuWyZ46wsOVW7phwAAAAAASUVORK5CYII="};
